export default {
    data() {
        return {
           iconsTabs: {
               active: 'fa icon-time',
               closed: 'fa icon-approved',
               available: 'fa icon-available',
               in_lending: 'fa icon-time',
               not_returned: 'fa icon-pending-return',
               pending_reception: 'fa icon-shopping-cart-tab',
               broken: 'fa icon-roto',
               retired: 'fa icon-retirado',
               not_received: 'fa icon-no-recibido',
               sold: 'fa icon-vendido',
               reserved: 'fa icon-reservado',
               clear: 'fa icon-limpieza'
           }
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/iconsTabs.js